// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2trbX","type":"styles_type__1eTCV","choices":"styles_choices__DwaoM"};